import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import OrganizerList, { Header } from '../../pages/OrganizerList/OrganizerList';
import {
    getEventProductsSmallZoneRequested,
    getEventProductsSmallZoneClear,
    getEventProductsStandardZoneRequested,
    getEventProductsStandardZoneClear,
    getEventProductsBigZoneRequested,
    getEventProductsBigZoneClear,
    getEventProductsRequested,
    getEventProductsClear,
    setSelectedOrganizers,
    clearSelectedOrganizers,
    setSearchCondition,
    clearSearchCondition,
    setViewMode,
    getEventProductsGrandZoneRequested,
    getEventProductsGrandZoneClear,
} from '../../actions/OrganizerList';
import {
    getCompanyInfoRequested,
    getCompanyInfoClear,
} from '../../actions/OrganizerPosterList';
import {
    getFavoriteCompaniesRequested,
    getFavoriteCompaniesClear,
    updateFavoriteCompaniesRequested,
    updateFavoriteCompaniesClear,
} from '../../actions/FavoriteCompanies';

import { GetJobsRequested, GetCategoryRequest, GetZonesRequested } from '../../actions/CommonOptions';
import Selector from '../../selectors/OrganizerList';
import withAuthUser from '../../common/WithAuthUser';
import { BOOTH_TYPE } from '../../common/Constants';
import { getSettingCustomTextRequested, getSettingCustomTextClear ,
         getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear    ,
} from '../../actions/AdminSettingCustom';

const formatParams = (params, boothType, language) => _.pickBy({
    company_name: params.company && params.company.trim(),
    product_name: params.product && params.product.trim(),
    company_type: params.type && params.type,
    zone_id: params.zone_id && params.zone_id,
    page_size: params.page_size && params.page_size,
    page: params.page,
    ...{ ...boothType && { organizer_booth: boothType } },
    language,
});

const formatParamsCompany = (params, locale) => _.pickBy({
    search: params.company && params.company.trim(),
    company_type: params.type && params.type,
    zone_id: params.zone_id && params.zone_id,
    page_size: params.page_size && params.page_size,
    page: params.page,
    language: locale,
});

const mapStateToProps = (state) => {
    const isLoading = state.commonOptions.Options.isFetching
    || state.registration.registrationViewer.isFetching
    || state.organizerList.getProducts.isFetching
    || state.organizerList.getSmallBooth.isFetching
    || state.organizerList.getStandardBooth.isFetching
    || state.organizerList.getBigBooth.isFetching
    || state.organizerList.getGrandBooth.isFetching
    || state.favoriteCompanies.get.isFetching
    || state.commonOptions.zones.isFetching
    || state.organizerPosterList.getList.isFetching
    || state.adminSettingCustom.getCustomText.isFetching;
    const successGetProducts = state.organizerList.getProducts.success;
    const errorsGetProducts = state.organizerList.getProducts.errors;
    const successGetProductSmallBooth = state.organizerList.getSmallBooth.success;
    const errorsGetProductSmallBooth = state.organizerList.getSmallBooth.errors;
    const successGetProductStandardBooth = state.organizerList.getSmallBooth.success;
    const errorsGetProductStandardBooth = state.organizerList.getSmallBooth.errors;
    const successGetProductBigBooth = state.organizerList.getSmallBooth.success;
    const errorsGetProductBigBooth = state.organizerList.getSmallBooth.errors;
    const successGetProductGrandBooth = state.organizerList.getGrandBooth.success;
    const errorsGetProductGrandBooth = state.organizerList.getGrandBooth.errors;
    
    return ({
        language: state.locale.changeLanguage.lang?.language || 'ja',
        locale: state.locale.lang.current,
        langOther: state.locale?.changLangOther?.current || '',
        companyIDs: state.favoriteCompanies.get.data.company_ids,
        errorsGetProducts,
        errorsGetProductBigBooth,
        errorsGetProductSmallBooth,
        errorsGetProductStandardBooth,
        errorsGetProductGrandBooth,
        eventInfo: state.registrationOrganizer.registrationOrganizer.data,
        isAuthorized: state.auth.credential.isAuthorized,
        isWeakAuth: state.auth.credential.data?.isWeakAuth,
        isLoading,
        options: state.commonOptions.Options.data,
        zones: state.commonOptions.zones.data,
        allProducts4Cate: Selector.createAllProdcuts4CategorySelector()(state),
        allProducts: Selector.createProductsSelector()(state),
        productsBigBooth: Selector.createProductListBigZoneSelector()(state),
        productsSmallBooth: Selector.createProductListSmallZoneSelector()(state),
        productsStandardBooth: Selector.createProductListStandardZoneSelector()(state),
        productsGrandBooth: Selector.createProductListGrandZoneSelector()(state),
        successGetProducts,
        successGetProductBigBooth,
        successGetProductSmallBooth,
        successGetProductStandardBooth,
        successGetProductGrandBooth,
        jobs: state.commonOptions.jobs.data,
        category: state.commonOptions.category.data,
        selectedOrganizerList: state.organizerList.selectedOrganizer.organizers,
        searchData: state.organizerList.searchData.data,
        updateFavoriteSuccess: state.favoriteCompanies.update.success,
        viewMode: state.organizerList.viewMode.viewMode,
        companyList: state.organizerPosterList.getList.listCompany.results,
        isCheckEvent: state.registration.registrationViewer.successInformation,
        customText: state.adminSettingCustom.getCustomText.data?.content,
        pageCompanyList: state.organizerPosterList.getList.data,
        pageProductList: state.organizerList.getProducts.data,
        /*  ★★ */ 
        customTimerctrl :state.adminSettingCustom.getCustomTimerctrl.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getEventProducts: (event, params, locale) => {
        const validJSONParams = formatParams(params, '', locale);
        dispatch(getEventProductsRequested({ event, params: validJSONParams }));
    },
    clearEventProducts: () => {
        dispatch(getEventProductsClear());
    },
    getEventProductsBigZone: (event, params, locale) => {
        const validJSONParams = formatParams(params, BOOTH_TYPE.BIG, locale);
        dispatch(getEventProductsBigZoneRequested({
            event,
            params: validJSONParams,
            boothType: BOOTH_TYPE.BIG,
            language: locale,
        }));
    },
    getEventProductsSmallZone: (event, params, locale) => {
        const validJSONParams = formatParams(params, BOOTH_TYPE.SMALL, locale);
        dispatch(getEventProductsSmallZoneRequested({
            event,
            params: validJSONParams,
            boothType: BOOTH_TYPE.SMALL,
            language: locale,
        }));
    },
    getEventProductsStandardZone: (event, params, locale) => {
        const validJSONParams = formatParams(params, BOOTH_TYPE.STANDARD, locale);
        dispatch(getEventProductsStandardZoneRequested({
            event,
            params: validJSONParams,
            boothType: BOOTH_TYPE.STANDARD,
            language: locale,
        }));
    },
    getEventProductsGrandZone: (event, params, locale) => {
        const validJSONParams = formatParams(params, BOOTH_TYPE.GRAND, locale);
        dispatch(getEventProductsGrandZoneRequested({
            event,
            params: validJSONParams,
            boothType: BOOTH_TYPE.GRAND,
            language: locale,
        }));
    },
    clearEventProductsBigZone: () => {
        dispatch(getEventProductsBigZoneClear());
    },
    clearEventProductsSmallZone: () => {
        dispatch(getEventProductsSmallZoneClear());
    },
    clearEventProductsStandardZone: () => {
        dispatch(getEventProductsStandardZoneClear());
    },
    clearEventProductsGrandZone: () => {
        dispatch(getEventProductsGrandZoneClear());
    },
    updateFavoriteCompanies: (companyIDs, locale) => {
        dispatch(updateFavoriteCompaniesRequested({ companyIDs, language: locale }));
    },
    getFavoriteCompanies: (locale) => {
        dispatch(getFavoriteCompaniesRequested({ language: locale }));
    },
    clearFavoriteCompanies: () => {
        dispatch(getFavoriteCompaniesClear());
    },
    fetchJobs: (shortName) => {
        dispatch(GetJobsRequested(shortName));
    },
    fetchCategory: (shortName) => {
        dispatch(GetCategoryRequest(shortName));
    },
    setSelectedOrganizer: (params) => {
        dispatch(setSelectedOrganizers(params));
    },
    clearSelectedOrganizers: () => {
        dispatch(clearSelectedOrganizers());
    },
    setSearchCondition: (params) => {
        dispatch(setSearchCondition(params));
    },
    clearSearchCondition: () => {
        dispatch(clearSearchCondition());
    },
    clearUpdateFavorite: () => {
        dispatch(updateFavoriteCompaniesClear());
    },
    fetchZones: (shortName) => {
        dispatch(GetZonesRequested(shortName));
    },
    setViewMode: (viewMode) => {
        dispatch(setViewMode(viewMode));
    },
    getCompaniesByEvent: (shortName, params, locale) => {
        const validJSONParams = formatParamsCompany(params, locale);
        dispatch(getCompanyInfoRequested({ event: shortName, params: validJSONParams }));
    },
    clearCompanyList: () => {
        dispatch(getCompanyInfoClear());
    },
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    clearCustomText: () => {
        dispatch(getSettingCustomTextClear());
    },
     /*　★★ */    
    getSettingCustomTimerctrl: (params) =>{
    	  dispatch(getSettingCustomTimerctrlRequest(params));
    },
    clearCustomTimerctrl: () =>{
    	  dispatch(getSettingCustomTimerctrlClear() );
    },    
});

export const HeaderOrganizerList = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(OrganizerList);
